import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=58631e18&scoped=true"
var script = {}
import style0 from "./Shipping.vue?vue&type=style&index=0&id=58631e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58631e18",
  null
  
)

export default component.exports